export enum DeliveryModeEnum {
  POS = 'POS',
  COURIER = 'COURIER',
  POST_OFFICE = 'POST_OFFICE',
  EMAIL = 'EMAIL'
}
